import { AutocompleteItem, SelectItem } from "@heroui/react";

import type { ItemSelect } from "@onesolution/components";

export function defaultSelectItemsRender(selection: object) {
	const item = selection as ItemSelect;

	return <SelectItem textValue={item.name || "none"}>{item.name}</SelectItem>;
}

export function defaultAutocompleteItemsRender(selection: object) {
	const item = selection as ItemSelect;

	return (
		<AutocompleteItem textValue={item.name || "none"}>
			{item.name}
		</AutocompleteItem>
	);
}

export const shouldDisplayItemPicker = (
	isLoading: boolean | undefined,
	items: Iterable<object> | undefined,
) => {
	const array = items as Array<unknown>;
	if (isLoading || !items || array.length > 0) return true;

	return false;
};
